export default "__VITE_ASSET__aNbywF65__"